export default __webpack_public_path__ + "static/media/offices.f2a9c35f.svg";